import React, { useState } from 'react';
import ApiRequestService from '../component/ApiRequestService';
import SFConfirmAlert from '../component/custom/SFConfirmAlert';

const DuplicateTutorial = ({ open, quizID, onComplete, onCancel }) => {
    const [loading, setLoading] = useState(false);

    const onCopyClicked = () => {
        setLoading(true);
        const payload = { quizID: quizID, courseID: 0, sectionIDs: [0] };
        ApiRequestService({
            method: 'post',
            url: '/copyquiz',
            data: payload
        })
            .then(res => {
                if (res && res.data && res.data.data) {
                    if (onComplete) {
                        onComplete(res.data.data);
                    }
                }
            })
            .catch(error => {
                console.error('Error when duplicating tutorial ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <SFConfirmAlert
            open={open}
            title="Duplicate Tutorial"
            description="Are you sure you want to duplicate this tutorial?"
            onConfirm={onCopyClicked}
            onCancel={onCancel}
            loading={loading}
        />
    );
};

export default DuplicateTutorial;
